import React from 'react';
import PropTypes from 'prop-types';

const ProfileDetailItem = ({ label, value, valueClass }) => {
  return (
    <div className="profile-item-wrapper">
      <div className="profile-item-label">{label}</div>
      <div className={`profile-item-text ${valueClass}`}>{value}</div>
    </div>
  );
};

ProfileDetailItem.propTypes = {
  label: PropTypes.string,
  value: PropTypes.string,
  valueClass: PropTypes.string
};

ProfileDetailItem.defaultProps = {
  valueClass: ''
};

export default ProfileDetailItem;



// WEBPACK FOOTER //
// ./src/pages/pointofsale/modules/serving/component/ProfileDetailItem.js